/**
 * date-distance.js
 */

import React from 'react';
import {
  Tooltip,
} from '@mui/material';
import { parseISO, format, formatDistanceStrict } from 'date-fns';
import locale from 'date-fns/locale/en-US'


// Concise format (see https://github.com/date-fns/date-fns/issues/1706#issuecomment-836601089)
const formatDistanceConciseLocale = {
  lessThanXSeconds: '{{count}}s',
  xSeconds: '{{count}}s',
  halfAMinute: '30s',
  lessThanXMinutes: '{{count}}m',
  xMinutes: '{{count}}m',
  aboutXHours: '{{count}}h',
  xHours: '{{count}}h',
  xDays: '{{count}}d',
  aboutXWeeks: '{{count}}w',
  xWeeks: '{{count}}w',
  aboutXMonths: '{{count}}m',
  xMonths: '{{count}}m',
  aboutXYears: '{{count}}y',
  xYears: '{{count}}y',
  overXYears: '{{count}}y',
  almostXYears: '{{count}}y',
}

function formatDistanceConcise(token, count, options) {
  options = options || {}

  const result = formatDistanceConciseLocale[token].replace('{{count}}', count)

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result
    } else {
      return result + ' ago'
    }
  }

  return result
}


export default function DateDistance(props) {
  const {
    component,
    componentProps,
    cozyPrefix,
    dateStart,
    dateEnd,
    options,
    placement,
    suffix,
    showTime,
    tooltipPrefix,
    concise,
  } = props;
  const stringFormat = showTime ? 'MMMM dd, yyyy h:mm aaa' : 'MMMM dd, yyyy';
  const Component = component ? component : 'span';
  const dateStartObj = dateStart 
    ? typeof dateStart === 'string' ? parseISO(dateStart) : dateStart 
    : new Date();
  const dateEndObj = dateEnd 
    ? typeof dateEnd === 'string' ? parseISO(dateEnd) : dateEnd
    : new Date();
  const dateString = (
    <>
      <div>
        {tooltipPrefix}
        {format(dateStartObj, stringFormat)}
      </div>
      {dateEnd ? <div>to</div> : ''}
      {dateEnd ? <div>{format(dateEndObj, stringFormat)}</div> : ''}
    </>
  );

  const localOptions = {...options};
  if (concise) {
    localOptions.locale = {
      ...locale,
      formatDistance: formatDistanceConcise,
    };
  }

  const dateDistance = formatDistanceStrict(dateStartObj, dateEndObj, localOptions);

  return (
    <Tooltip
      title={dateString}
      placement={placement ? placement : 'right-start'}
      arrow
    >
      <Component {...componentProps}>
        {cozyPrefix}{dateDistance} {suffix}
      </Component>
    </Tooltip>
  );
}